import React, { Component } from 'react'
import Swiper from 'react-id-swiper'
import styles from './index.module.less'
import Utils from '../../lib/utils'
import './swiper.less'

export default class FocusSwiper extends Component {
  static defaultProps = {
    data: {}
  }
  constructor (props) {
    super(props)
    this.state = {
      gallerySwiper: null,
      thumbnailSwiper: null,
      isHideNav: true,
      bottom: 0
    }
    this.imgWidth = 1664
    this.data = props.data
    this.componentSpm = this.getComponentSpm(this.data.spm)
    this.length = this.data.length
    this.galleryRef = this.galleryRef.bind(this)
    this.thumbRef = this.thumbRef.bind(this)
    this.itemClickFn = this.itemClick.bind(this)
    this.isAddSlideChangEvents = false
    this.isCanPlay = true
    this.isFirst = true
    this.isLast = false
  }

  getComponentSpm (spmC) {
    const spmAB = Utils.getSpmAB()
    return `${spmAB.spmA}.${spmAB.spmB}.${spmC}`
  }

  // componentWillUpdate
  componentWillUpdate (nextProps, nextState) {
    if (nextState.gallerySwiper && nextState.thumbnailSwiper) {
      const { gallerySwiper, thumbnailSwiper } = nextState
      gallerySwiper.controller.control = thumbnailSwiper
      thumbnailSwiper.controller.control = gallerySwiper
      // 添加indexchange监听
      if (!this.isAddSlideChangEvents) {
        this.isAddSlideChangEvents = true
        thumbnailSwiper.on('slideChange', () => {
          this.slideIndexChange(this.state.thumbnailSwiper.previousIndex, this.state.thumbnailSwiper.realIndex)
        })
      }
    }
    return true
  }

  componentDidMount () {
    if (this.data.bottom) {
      this.setState({ isHideNav: false, bottom: this.data.bottom })
    } else {
      this.setState({ isHideNav: false })
    }

    // if (document.body.clientWidth) {
    //   const _screenWidth = document.body.clientWidth > 1664 ? 1664 : document.body.clientWidth
    //   this.setState({ imgWidth: _screenWidth })
    // }

    /***
     * 添加广告控制首焦和尾焦暂停事件
     */
    if (this.isFirstAd && window._adSDk && window._adSDk.params) {
      window._adSDk.params.onFocuseWheelPlay = () => {
        this.startPlay()
      }
      window._adSDk.params.onFocuseWheelPause = () => {
        this.stopPlay()
      }
    }
  }

  galleryRef (ref) {
    if (ref) this.setState({ gallerySwiper: ref.swiper })
  }

  thumbRef (ref) {
    if (ref) this.setState({ thumbnailSwiper: ref.swiper })
  }

  // 实现hover鼠标切换事件
  handleMouseEnter (index) {
    if (!this.isCanPlay) {
      return
    }
    if (index !== this.state.thumbnailSwiper.activeIndex) {
      this.state.thumbnailSwiper.slideTo(index)
    }
  }

  slideIndexChange (preindex, index) {
    // 回调当前切换到那一帧
    if (window._adSDk && this.isFirstAd) {
      if (index === 0) {
        console.log('window._adSDk.invoke(enterFirst)')
        window._adSDk.invoke('enterFirst', { adId: this.adFirstId })
      }
      if (preindex === 0) {
        console.log('window._adSDk.invoke(leaveFirst)')
        window._adSDk.invoke('leaveFirst', { adId: this.adFirstId })
      }
    }

    if (window._adSDk && this.isLastAd) {
      if (index === this.length - 1) {
        console.log('window._adSDk.invoke(enterlast)')
        window._adSDk.invoke('enterlast', { adId: this.adLastId })
      }
      if (preindex === this.length - 1) {
        console.log('window._adSDk.invoke(leavelast)')
        window._adSDk.invoke('leavelast', { adId: this.adLastId })
      }
    }
  }

  stopPlay () {
    if (!this.isCanPlay) {
      return
    }
    this.state.gallerySwiper && this.state.gallerySwiper.autoplay && this.state.gallerySwiper.autoplay.stop()
    this.isCanPlay = false
  }

  startPlay () {
    if (this.isCanPlay) {
      return
    }
    this.state.gallerySwiper && this.state.gallerySwiper.autoplay && this.state.gallerySwiper.autoplay.start()
    this.isCanPlay = true
  }

  itemClick (args) {
    const el = args.currentTarget
    if (el && el.href && el.href.indexOf('spm=') < 0) {
      const spmd = el.getAttribute('data-spm')
      el.href = Utils.jointUrlParam(el.href, { spm: `${this.componentSpm}.${spmd}` })
    }
    Utils.sendClickLog(el)
  }

  getAdExtId (index) {
    return `focus_slideitem_${this.data.moduleId}_${index}`
  }

  render () {
    if (!this.props.data || this.length < 1) {
      return ''
    }
    const gallerySwiperParams = {
      spaceBetween: 30,
      effect: 'fade',
      // loop: true,
      // pagination: {
      //   el: '.swiper-pagination',
      //   clickable: false
      // },
      autoplayDisableOnInteraction: false,
      autoplay: {
        delay: 5000,
        // stopOnLastSlide: false,
        loop: true,
        autoplayDisableOnInteraction: false
        // disableOnInteraction: true
      }
    }
    const thumbnailSwiperParams = {
      direction: 'vertical',
      paceBetween: 10,
      centeredSlides: true,
      slidesPerView: 'auto',
      touchRatio: 0.2,
      slideToClickedSlide: true
    }

    const _navClassName = this.state.isHideNav ? `focus_nav ${styles.focus_nav} ${styles.focus_nav_hide}` : `focus_nav ${styles.focus_nav}`
    const style = this.state.bottom ? { marginBottom: `${this.state.bottom}px` } : {}
    return (
      <div className={styles.focus_wrap}
        style={style}
        {...Utils.getComponentSpmData(this.data)}>
        <Swiper {...gallerySwiperParams} ref={this.galleryRef}>
          {
            this.data.focusList.map((item, index) => {
              const imgUrl = Utils.imageOss(item.img, { w: this.imgWidth, q: 80 })
              const adData = {}
              if (this.data.isFirstAd && index === 0) {
                adData.adid = this.data.adFirstId
                adData.extId = this.getAdExtId(index)
                adData.adtype = 'firstAd'
              }
              if (this.data.isLastAd && index === this.data.length - 1) {
                adData.adid = this.data.adLastId
                adData.extId = this.getAdExtId(index)
                adData.adtype = 'lastAd'
              }
              return (
                <div key={index}>
                  <div
                    data-adext={adData.extId}
                    data-adpid={adData.adid}
                    data-adtype={adData.adtype}
                    className={styles.focus_item} style={{
                      backgroundImage: `url(${imgUrl})`,
                      backgroundColor: `${item.color || '#262626'}`
                    }}>
                    <a
                      {...Utils.getItemSpmData(item)}
                      {...Utils.getATagProps(item, true)}
                      className={styles.focus_cover}
                      style={{
                        backgroundImage: `url(${item.background || '//gw.alicdn.com/mt/TB1Sw8Tom_I8KJjy0FoXXaFnVXa-1664-520.png'})`
                      }}
                      title={item.title}
                      onClick={this.itemClickFn} />
                  </div>
                </div>

              )
            })
          }
        </Swiper>
        <div className={_navClassName}>
          <Swiper {...thumbnailSwiperParams} ref={this.thumbRef}>
            {
              this.data.focusList.map((item, index) => {
                return (
                  <a id={this.getAdExtId(index)}
                    {...Utils.getItemSpmData(item, true)}
                    {...Utils.getATagProps(item, true)}
                    key={index}
                    onClick={this.itemClickFn} >
                    <div className={styles.nav_slide}
                      onMouseEnter={this.handleMouseEnter.bind(this, index)}>
                      <h2> <span className={`nav_index nav_index_${index + 1}`}>{index + 1}</span>{item.title}</h2>
                      {/* <span className='title_split'>:</span> */}
                      <div className={`sub_title ${styles.sub_title}`}>{item.subtitle}</div>
                    </div>
                  </a>
                )
              })
            }
          </Swiper>
        </div>
      </div>
    )
  }
}
